<script lang="ts">
import { defineComponent, ref, computed, onMounted } from 'vue'

export default defineComponent({
  name: 'PaginationRegistrationStep',

  props: {
    /**
     * 最大ステップ数
     */
    maxStep: {
      type: Number,
      default: 4,
      validator: (v: number) => {
        return v >= 1 && Number.isInteger(v)
      },
    },

    /**
     * 現ステップ数（current 表示のステップ数）
     */
    currentStep: {
      type: Number,
      default: 1,
      validator: (v: number) => {
        return v >= 1 && Number.isInteger(v)
      },
    },
  },

  setup(props) {
    const localCurrentStep = ref(0)

    /**
     * props で指定された最大ステップ数までの数字配列を生成
     * @example props.maxStep: 5 の場合 -> [1, 2, 3, 4, 5]
     */
    const stepItems = computed(() => {
      return Array.from({ length: props.maxStep }, (_, i) => i + 1)
    })

    onMounted(() => {
      // props で指定された current step 数が、max step 数より大きい値の場合、便宜的に max step 数の値を current として扱う
      if (props.currentStep > props.maxStep) {
        console.error('invalid current step number whitch larger than max step number. please set the current step number to a value smaller than the max step number.')
        localCurrentStep.value = props.maxStep
      } else {
        localCurrentStep.value = props.currentStep
      }
    })

    return {
      // data
      localCurrentStep,

      // computed
      stepItems,
    }
  }
})
</script>

<template>
  <div class="o-list__paginationRegistrationStep">
    <dl class="o-list__paginationRegistrationStep--unit">
      <dt class="o-list__paginationRegistrationStep--term">
        STEP
      </dt>

      <dd class="o-list__paginationRegistrationStep--description">
        <div class="o-list__registrationStep">
          <ol class="o-list__registrationStep--items">
            <li
              v-for="(item, index) in stepItems"
              :key="index"
              :class="[
                'o-list__registrationStep--item',
                { 'is-current': item === localCurrentStep },
              ]">
              {{ item }}
            </li>
          </ol>
        <!-- /.o-list__registrationStep --></div>
      </dd>
    </dl>
  <!-- /.o-list__paginationRegistrationStep --></div>
</template>

<style lang="sass" scoped>
// object
.o-list__paginationRegistrationStep
  margin:
    top: 0.5em
    bottom: 1em

  &:first-child
    margin-top: 0

  & &--unit
    display: flex
    align-items: center
    justify-content: center

  & &--term
    line-height: 1
    color: $font-gold
    font-size: $font-small

  & &--description
    margin-left: 0.5em

    &:first-child
      margin-left: 0

.o-list__registrationStep
  & &--items
    display: flex

  & &--item
    width: 1.5em
    line-height: 1.5
    color: $font-white
    text-align: center
    margin-left: 0.25em
    background-color: rgba($bg-gray, 1)
    border-radius: 50%

    &:first-child
      margin-left: 0

    &.is-current
      background-color: rgba($bg-gold, 1)
</style>
